import GetItOnGooglePlay from '../../assets/images/playstore/getitongoogleplay.png';
import clsx from 'clsx';

export const GetItOnGooglePlayBanner = (props: { onClick: () => void; large?: boolean }) => {
  return (
    <img
      src={GetItOnGooglePlay}
      className={clsx('store-banner', { 'store-banner--large': props.large })}
      alt="Get it on Google Play"
      onClick={props.onClick}
    />
  );
};
